import type { ApiClient } from '@classgo/app-kit';
import type { SetupState, SetupStepId } from '@classgo/shared';
import { queryOptions } from '@tanstack/react-query';

/**
 * The guided setup (`GET /setup`, ticket #62) and its skip marks, as query options and calls.
 */
export const setupQueries = {
  state: (api: ApiClient) =>
    queryOptions({
      queryKey: ['setup'],
      queryFn: () => api.request<SetupState>('/setup'),
      retry: false,
    }),
};

/**
 * The skip calls of the guided setup.
 *
 * @param {ApiClient} api -- The client.
 * @returns The calls.
 */
export const setupApi = (api: ApiClient) => ({
  skip: (step: SetupStepId) =>
    api.request<SetupState>(`/setup/steps/${step}/skip`, { method: 'POST' }),
  unskip: (step: SetupStepId) =>
    api.request<SetupState>(`/setup/steps/${step}/skip`, { method: 'DELETE' }),
});
